query TagsAutocomplete(
  $input: String = ""
  $value: [ID!] = []
  $filter: AutocompleteTagsFilterInput
) {
  autocomplete: autocompleteTags(
    input: $input
    value: $value
    filter: $filter
  ) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
